import { Control, Controller, useController } from 'react-hook-form'
import React from 'react'
import { t } from 'ttag'

import { activityTypes, FormData } from '../../ChallengeAdmin'
import YumSelect from '../../../../components/YumSelect/YumSelect'
import { CustomTypeCategory } from '../../../../services/CustomTypes'
import { ignoreCategoriesForPoints } from './ChallengePoints'
import { YumActivityIcon } from '../../../../components/YumActivityIcon/YumActivityIcon'

interface ChallengePointsUnitFieldProps {
  control: Control<FormData, any>
  name: any
  onActivityTypeChange: any
  fields: any[]
  index: number
}

export default function ChallengePointsActivityTypeField(props: ChallengePointsUnitFieldProps) {
  const { control, name, onActivityTypeChange, fields, index } = props
  const {
    field: { onChange, name: controllerName, value, ref },
  } = useController({
    control,
    name,
  })

  const handleChange = (...event: any[]) => {
    onChange(...event)
    onActivityTypeChange(index, ...event)
  }

  return (
    <Controller
      name={controllerName}
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumSelect
          label={t`Activity type`}
          StartIconComponent={<YumActivityIcon category={otherField.value} color={'darkBlue'} isInactive={true} />}
          /*sideMargin={41}*/
          inputRef={ref}
          {...otherField}
          style={{ marginBottom: '12px' }}
          onChange={handleChange}
        >
          <optgroup label={t`Automated sync`}>
            {activityTypes.map(
              (activityType, keyIndex) =>
                /* @ts-ignore */
                !ignoreCategoriesForPoints.includes(activityType.value) &&
                activityType.usesIntegration && (
                  <option
                    key={keyIndex}
                    value={activityType.value}
                    disabled={fields.some((f) => f.category === activityType.value && f.category !== otherField.value)}
                  >
                    {activityType.label}
                  </option>
                ),
            )}
            {/*<option value={CustomTypeCategory.OTHER_MIN}>{t`Other exercise minutes`}</option>*/}
          </optgroup>
          <optgroup label={t`Manual entry`}>
            {activityTypes
              .sort((a, b) => a.label.localeCompare(b.label))
              .map(
                (activityType, keyIndex) =>
                  /* @ts-ignore */
                  !ignoreCategoriesForPoints.includes(activityType.value) &&
                  !activityType.usesIntegration && (
                    <option
                      key={keyIndex}
                      value={activityType.value}
                      disabled={fields.some(
                        (f) => f.category === activityType.value && f.category !== otherField.value,
                      )}
                    >
                      {activityType.label}
                    </option>
                  ),
              )}
          </optgroup>
          <optgroup label={t`Custom`}>
            <option value={CustomTypeCategory.CUSTOM_SIMPLE}>
              {t`Custom`} ({t`simple`.toLowerCase()})
            </option>
            <option value={CustomTypeCategory.CUSTOM_WITH_AMOUNT}>
              {t`Custom`} ({t`with amount`.toLowerCase()})
            </option>
          </optgroup>
        </YumSelect>
      )}
    />
  )
}
